// extracted by mini-css-extract-plugin
var _1 = "tjs-setting-panel__dropdown-inner";
var _2 = "tjs-setting-panel__dropdown-inner";
export { _1 as "dropdown-inner", _2 as "dropdownInner" }
export default { "dropdown-inner": _1, "dropdownInner": _2 }
